import { EquipmentDto } from "src/dtos/equipment/equipmentDto";
import { ChemicalTransDto } from "src/dtos/chemicalTrans/chemicalTransDto";
import { formatDate } from "src/utils/string/stringUtil";

/**
 * MST4050_R01 헤더 DTO
 * 의약품 정보 (EquipmentDto 확장, equipment_class = 'CHEMICAL')
 */
export interface MST4050_R01HeaderDto extends EquipmentDto {
	equipmentClass: string;			// 설비분류 (CHEMICAL)
	equipmentTypeNm: string;		// 약품유형명 (CHEMICAL_TYPE 코드명)
	eqmUnit: string;				// 단위
	eqmQty: number;				// 보유량
	useCustomer: string;			// 매입처코드
	useCustomerNm: string;			// 매입처명
}

/**
 * MST4050_R01 디테일 DTO
 * 입출고 내역 (eqm_chemical_trans)
 */
export interface MST4050_R01DetailDto extends ChemicalTransDto {
	isBaseRow?: boolean;			// 기초재고 가상행 여부
	eqmUnit?: string;				// 화면 편집용 단위(헤더 eqmUnit과 동기화)
	inspectTypeNm: string;			// 변경내역명
	compNm: string;					// 사업장명
	customNm: string;				// 거래처명
	inspectEmpNm: string;			// 처리담당자명

	// 키 변경 대응용 old 키
	oldInspectDt?: string;
	oldEqmCd?: string;
	oldInspectCycle?: string;
	oldInspectType?: string;

	// 프론트 그리드의 신규·수정·삭제 표시를 위한 UI 상태
	inserted: boolean;
	isModified: boolean;
	deleted?: boolean;

	insertUserNm: string;			// 등록자명 (조인)
}

/**
 * MST4050_R01 통합 DTO (조회조건 / 저장 요청·응답 공용)
 */
export interface MST4050_R01Dto {
	headerDto?: MST4050_R01HeaderDto;
	detailDtoList?: MST4050_R01DetailDto[];
	listLength?: number;
	refetchListLength?: number;
	compCd?: string;
	equipmentType?: string;
	equipmentCd?: string;
	equipmentNm?: string;
	eqmCd?: string;
	eqmStatus?: string;
	searchYm?: string;
	baseQty?: number;
}

/**
 * 기본 MST4050_R01HeaderDto 값
 */
export const defaultMST4050_R01HeaderDto: MST4050_R01HeaderDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	equipmentCd: '',
	equipmentNm: '',
	equipmentClass: 'CHEMICAL',
	equipmentSpec: '',
	eqmSerial: '',					// CAS번호
	equipmentType: '',				// 약품유형 (CHEMICAL_TYPE)
	equipmentTypeNm: '',
	eqmUnit: '',					// 단위
	workplaceCd: '',
	equipmentSeq: 0,
	displaySeq: 0,
	compCd: '',
	compNm: '',
	eqmOrgcd: '',
	eqmOrgNm: '',
	eqmPerson: '',
	eqmPersonNm: '',
	useCustomer: '',				// 매입처
	useCustomerNm: '',
	eqmPower: 0,
	eqmVolt: 0,
	sizeHeight: 0,
	sizeWidth: 0,
	sizeDepth: 0,
	sizeWeight: 0,
	otherSpec: '',
	manufacturerNm: '',
	manufactureDt: formatDate(new Date()),
	purchaseNm: '',
	purchaseDt: formatDate(new Date()),
	purchaseAmt: 0,
	linkIp: '',
	linkPort: '',
	gatheringCycle: 0,
	instrucTag: '',
	virtualEqm: '',
	eqmImage: '',
	eqmImage2: '',
	eqmStatus: '',
	eqmStatusNm: '',
	eqmQty: 0,						// 보유량 (읽기전용, 백엔드 동기화)
	disposalDt: formatDate(new Date()),
	remark: '',

	inserted: false,
	isModified: false,

	insertDt: new Date(),
	insertUser: '',
	insertForm: '',
	updateDt: new Date(),
	updateUser: '',
	updateForm: ''
}

/**
 * 기본 MST4050_R01DetailDto 값
 */
export const defaultMST4050_R01DetailDto: MST4050_R01DetailDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	inspectDt: formatDate(new Date()),
	eqmCd: '',
	inspectCycle: '',
	inspectType: '',
	inspectTypeNm: '',
	compCd: '',
	compNm: '',
	customCd: '',
	customNm: '',
	inspectTime: '',
	transportQty: 0,
	inspectEmpno: '',
	inspectEmpNm: '',
	remark: '',

	inserted: false,
	isModified: false,
	deleted: false,
	isBaseRow: false,

	insertDt: new Date(),
	insertUser: '',
	insertUserNm: '',
	insertForm: '',
	updateDt: new Date(),
	updateUser: '',
	updateForm: ''
}
